import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, selectEntities } from '../reducers/item-reactions.reducer';

export const getItemReactionsState = createFeatureSelector<State>('itemReactionsState');

export const selectItemReactionsEntities = createSelector(getItemReactionsState, state => selectEntities(state));
